enum RouteTemplateType {
  xdb = 'xdb',
  oa = 'oa',
  index = 'index',
}

enum hundun_route_type {
  company,
  company_work,
}

export { 
  RouteTemplateType,
  hundun_route_type,
};
